type Options = {
  addDays?: number;
  addMonths?: number;
  addYears?: number;
};

export const getISOStringDate = (date: Date, options: Options) => {
  if (options.addDays) {
    date.setDate(date.getDate() + options.addDays);
  }
  if (options.addMonths) {
    date.setMonth(date.getMonth() + options.addMonths);
  }
  if (options.addYears) {
    date.setFullYear(date.getFullYear() + options.addYears);
  }
  return date.toISOString();
};
